<template>
  <div class="reservation-promo-input">
    <div class="form-group row clearfix" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <input class="form-control" type="text"
          :readonly="options.readOnly"
          :id="options.name"
          :value="value"
          @input="validate($event.target.value)"
          :name="options.name"/>
        <span class="form-validation-info" v-show="options.readOnly">Cannot modify promotional code</span>
        <span class="form-validation-info" v-show="description">{{ description }}</span>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {
  validationClass,
  validationMessage,
  validationIcon
} from '@/util/helpers'
import Api from '@/vuex/api'

export default {
  name: 'ReservationPromoInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          value: '',
          validCode: false,
          dirty: false
        }
      }
    }
  },
  data () {
    return {
      loadingMessage: 'Verifying...',
      customError: false,
      invalidMessage: 'Promo code entered is not valid',
      startDate: this.options.date.startDate,
      endDate: this.options.date.endDate,
      isValid: true,
      isDirty: false,
      isLoading: false,
      description: false,
      delayedValidate: false
    }
  },
  computed: {
    validationClass,
    validationMessage,
    validationIcon
  },
  methods: {
    validate (val = this.value) {
      if (val !== this.value) {
        if (this.delayedValidate) {
          this.delayedValidate.cancel()
          this.delayedValidate = false
        }
        this.isLoading = true
        this.delayedValidate = _.debounce(async (val) => {
          this.customError = false
          this.isValid = true
          this.description = false
          this.isDirty = true
          let instance = new Api()
          try {
            let data = await instance.validateReservationPromo({
              code: val,
              car: this.options.car,
              user: this.options.user,
              startDate: this.startDate,
              endDate: this.endDate
            })
            if (data.invalid) {
              this.isValid = false
              this.options.validCode = false
            } else if (data.errorMessage) {
              this.customError = data.errorMessage
              this.isValid = false
            } else {
              this.description = data.code.description
              this.isValid = true
            }
          } catch (e) {
            this.isValid = false
          }
          this.isLoading = false
        }, 1500, { 'leading': false, 'trailing': true })
        if (!this.options.required) {
          this.$emit('input', val)
          this.delayedValidate(val)
        } else {
          this.isLoading = false
          this.isValid = true
          this.isDirty = false
        }
      }
    },
    runWatcher (val, name) {
      switch (name) {
        case 'dateRange':
          this.startDate = val.startDate
          this.endDate = val.endDate
          this.validate()
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/ReservationPromoInput.vue